module.exports = __webpack_public_path__ + "49675b203470f47bdb029a4ca1306ccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_xlarge_x1/public/games/sm_image_1.jpg
// module id = 506
// module chunks = 0